import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import DynamicIcon from "./dynamic-icon";
import H6 from "./h6";

const Modal = ({ children, additionalclasses, isOpen, toggleModal, heading, ignoreX, childrenClass}) => {
  // Create or get the modal root element
  const getModalRoot = () => {
    let modalRoot = document.getElementById('modal-root');
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = 'modal-root';
      modalRoot.style.position = 'relative';
      modalRoot.style.zIndex = '2147483647'; // Maximum z-index value
      document.body.appendChild(modalRoot);
    }
    return modalRoot;
  };

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const modalContent = (
    isOpen && (
      <div 
        onClick={toggleModal} 
        className="fixed inset-0 grid items-center justify-center content-center backdrop-blur-sm bg-[#00000059]"
        style={{ zIndex: 2147483647 }} // Inline style as fallback
      >
        <div 
          onClick={(e) => e.stopPropagation()} 
          className={`grid content-start bg-white-200 dark:bg-grey-600 rounded-[8px] pb-[20px] ${additionalclasses}`}
        >
         {heading && !ignoreX && <div className={`flex ${heading ? 'justify-between' : 'justify-end'} py-[11px] px-[18px]`}>
            {heading && <span className="text-[14px] custom-text-grey-600 poppins-medium">{heading}</span>}
            {!ignoreX && <DynamicIcon onClick={toggleModal} name='x' size={18} color='custom-text-grey-800 cursor-pointer' />}
          </div>}
          {heading && <div className="border-b-[1px] custom-border-white-50 mb-[8px]"></div>}
          <div className={`px-[16px] ${childrenClass}`}>
            {children}
          </div>
        </div>
      </div>
    )
  );

  // Render modal using portal to body or modal root
  return isOpen ? createPortal(modalContent, getModalRoot()) : null;
};

export default Modal;